import Button from "../../atoms/button/button";
import './bannerDirigido.scss';
import { useNavigate } from "react-router-dom";

const BannerDirigido = ({
    urlambiente=window.location,
    title, 
    text, 
    imagen, 
    urlButon='/mentoria-financiera/diagnostico-financiero/#/formulario-salud-educacion-financiera/',
    urlBotonAlterno=null,
    textButon='Completa tu diagnóstico',
    mentoria=false

    }) => {

    const navigate = useNavigate();
    
    const navigateFinal = () => {
        navigate("/formulario-salud-educacion-financiera/");
      };

  return (
    <>
        <section className="bd-fast" 
        style={{backgroundImage: imagen ? `url(${imagen})` : 'none',}}>
        <div className="bd-fast__info">
            <h2>{title}</h2>
            <h3>{text}</h3>
        </div>
        <Button
            text={textButon}
            gtmClass="secondary"
            onClick={() => {
            window.open(
                urlBotonAlterno !== null ? `${urlBotonAlterno}` : `${urlambiente.origin}${urlButon}`
            );
            }}
        />
        </section>
        {mentoria &&(
            <Button
            text="Continuar"
            gtmClass="secondary"
            onClick={navigateFinal}
          />
        )}
    </>
  );
};

export default BannerDirigido;
